import PaymentError from './PaymentError.container';

export default PaymentError;
